import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "top_card_stock_detail"
}
const _hoisted_2 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StockImageTag = _resolveComponent("StockImageTag")!

  return (_ctx.stockInfo)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_StockImageTag, {
          imgUrl: _ctx.stockInfo.logoUrl,
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.goToStocksScreen(_ctx.stockInfo.symbol, _ctx.stockInfo.type)), ["stop"])),
          symbol: _ctx.stockInfo.symbol,
          toFixed: true,
          market: _ctx.stockInfo.type,
          stockData: _ctx.stockData,
          stockId: _ctx.stockInfo._id
        }, null, 8, ["imgUrl", "symbol", "market", "stockData", "stockId"]),
        _createElementVNode("p", {
          class: "c-pointer stock-symbol-info",
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (
        _ctx.goToStocksScreen(_ctx.stockInfo.symbol, _ctx.stockInfo.type)
      ), ["exact","self","stop"]))
        }, [
          _createTextVNode(_toDisplayString(_ctx.stockInfo.symbol) + " ", 1),
          _createElementVNode("span", null, _toDisplayString(_ctx.stockInfo.companyName), 1)
        ]),
        (_ctx.stockData)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: _normalizeClass(["stockId asdsad stockDetailsFlex", { 'create-view': _ctx.isCreateView }])
            }, [
              _createElementVNode("span", {
                class: "price",
                innerHTML: _ctx.$filters.systemNumberConvention(_ctx.stockData.price, true)
              }, null, 8, _hoisted_2),
              _createElementVNode("span", {
                class: _normalizeClass(["price__tag", 
          _ctx.stockData.changesPercentage >= 0 ||
          _ctx.stockData.changesPercentage == 'n/a'
            ? 'positive'
            : 'negative'
        ])
              }, [
                _createElementVNode("i", {
                  class: _normalizeClass(["fas", 
            _ctx.stockData.changesPercentage >= 0 ||
            _ctx.stockData.changesPercentage == 'n/a'
              ? 'fa-caret-up'
              : 'fa-caret-down'
          ])
                }, null, 2),
                _createTextVNode(" " + _toDisplayString(Math.abs(
            _ctx.$filters.systemNumberConvention(_ctx.stockData.changesPercentage)
          )) + "% ", 1)
              ], 2)
            ], 2))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}